// Copyright (c) 2020 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import {
  SearchRecentNarrativesRequestSchema,
  SearchRecentNarrativesResponse,
} from "generated/wisetime/user/preferences/v4/preferences_pb"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"
import { executor, Init, preferencesService } from "../../../app/rpc"
import { create } from "@bufbuild/protobuf"

type SearchRecentNarrativesRpc = (request: Init<typeof SearchRecentNarrativesRequestSchema>) => Observable<SearchRecentNarrativesResponse>

export const searchRecentNarratives = (searchRecentNarrativesRpc: SearchRecentNarrativesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.searchRecentNarratives.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(searchRecentNarrativesRpc),
        map(t => t),
        map(Slice.setCachedNarratives),
        catchError(_ => of(showSnackBar({
          message: t({ id: "msg_search_descriptions_failed", message: "Failed to search for descriptions. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
          messageType: "ERROR",
        }))),
      )),
    )

const searchRecentNarrativesRpc = (request: Init<typeof SearchRecentNarrativesRequestSchema>): Observable<SearchRecentNarrativesResponse> =>
  executor(() => preferencesService.searchRecentNarratives(create(SearchRecentNarrativesRequestSchema, request)))

export default searchRecentNarratives(searchRecentNarrativesRpc)
